import { isMobileAndInMvpOrExistingUsersExperiment } from '@atlassian/jira-mobile-web/src/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { projectSettingsServicedeskTicketTypesConfigRoute } from '@atlassian/jira-router-routes-project-settings-service-desk-ticket-types-config-routes/src/projectSettingsServicedeskTicketTypesConfigRoute.tsx';
import { projectSettingsServicedeskItsmTicketTypesConfigRoute } from '@atlassian/jira-router-routes-project-settings-service-desk-ticket-types-config-routes/src/projectSettingsServicedeskItsmTicketTypesConfigRoute.tsx';
import { projectSettingsServicedeskUnassignedTicketTypesConfigRoute } from '@atlassian/jira-router-routes-project-settings-service-desk-ticket-types-config-routes/src/projectSettingsServicedeskUnassignedTicketTypesConfigRoute.tsx';
import type { RouteName } from '@atlassian/jira-route-name-types/src/RouteName.tsx';

const REQUEST_TYPE_PAGE_ROUTES = [
	projectSettingsServicedeskTicketTypesConfigRoute.name,
	projectSettingsServicedeskItsmTicketTypesConfigRoute.name,
	projectSettingsServicedeskUnassignedTicketTypesConfigRoute.name,
];

export const shouldRouteShowQuickstartOnboarding = (routeName: RouteName) => {
	if (isMobileAndInMvpOrExistingUsersExperiment()) {
		return false;
	}

	const allowedRoutes: RouteName[] = [
		'servicedesk-queues-landing',
		'servicedesk-queues-custom-view',
		'legacy-project-settings-edit',
		'legacy-project-settings-people',
		'project-settings-servicedesk-customer-notifications',
		'project-settings-servicedesk-email',
		'project-settings-servicedesk-portal-settings',
		'project-settings-servicedesk-ticket-types-config',
		'project-settings-servicedesk-chat',
	];

	return allowedRoutes.includes(routeName);
};

export const shouldRenderRequestTypesTableViewSettings = (routeName: RouteName) =>
	REQUEST_TYPE_PAGE_ROUTES.includes(routeName) && fg('request_type_table_uplift');
